import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  copyToClipboard = (ev) => {
    navigator.clipboard.writeText(ev.currentTarget.innerHTML);
  };
}
